<template>
  <section id="prova" class="section-shell proof-section" data-theme="glow">
    <div class="proof-card" data-reveal style="font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif !important;">
      <div class="lead-block">
        <p>A confian&ccedil;a na <span class="word-brand">ZIMA</span> vem de precis&atilde;o.</p>
        <p>As leituras s&atilde;o pr&oacute;prias. Cir&uacute;rgicas. Sem copiar gurus. Sem repetir conte&uacute;do que todo mundo j&aacute; viu.</p>
        <p>Aqui, voc&ecirc; aprende a ler o mercado sem depender de n&oacute;s <em>&mdash; nem de ningu&eacute;m. Voc&ecirc; caminha com suas pr&oacute;prias pernas, com clareza e independ&ecirc;ncia.</em></p>
      </div>

      <div class="callouts">
        <p><strong>Desde novembro, o regime bear foi mapeado e datado &mdash; quebra por quebra, zona por zona.</strong></p>
        <p><strong>As leituras de BTC, ETH e alts est&atilde;o publicadas no Telegram, com data e hora.</strong></p>
        <p><strong>N&atilde;o precisa acreditar: o porqu&ecirc; veio antes do movimento. D&aacute; pra conferir.</strong></p>
      </div>

      <div class="divider-label italic-quote">Mas h&aacute; uma verdade simples:</div>
      <p class="strong italic-quote">Sozinho, voc&ecirc; leva anos. E o mercado n&atilde;o espera.</p>
      <p>O mercado recompensa timing. Pune atraso. E ignora quem n&atilde;o enxerga.</p>
      <p>Com a <span class="word-brand">ZIMA</span>, voc&ecirc; encurta anos de tentativa e erro. V&ecirc; o mercado com clareza e para de reagir tarde.</p>
      <p class="strong italic-quote">E enquanto aprende, decodifica a matrix.</p>
    </div>
  </section>
</template>

<script setup>
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Manrope:wght@500;600;700;800&family=Space+Grotesk:wght@500;600;700&display=swap');
.proof-section {
  padding: clamp(24px, 3.6vw, 34px);
  border: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  overflow: visible !important;
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif !important;
}

.proof-section,
.proof-section * {
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif !important;
}

.proof-section::before {
  display: none !important;
}


.proof-card,
.proof-card * {
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif !important;
}
.proof-card {
  border-radius: 16px;
  border: 1px solid rgba(115, 148, 240, 0.22);
  background: linear-gradient(165deg, rgba(11, 14, 24, 0.9), rgba(8, 10, 18, 0.92));
  padding: 16px;
  display: grid;
  gap: 10px;
  position: relative;
  overflow: hidden;
}

.proof-card::before {
  content: '';
  position: absolute;
  inset: 0 12px auto;
  height: 2px;
  border-radius: 999px;
  background: linear-gradient(90deg, rgba(78, 115, 223, 0), rgba(118, 150, 240, 0.84) 22%, rgba(166, 118, 228, 0.8) 78%, rgba(155, 89, 182, 0));
}

.proof-card p {
  margin: 0;
  color: #d1dbf0;
  line-height: 1.5;
  font-size: clamp(1.04rem, 1.15vw, 1.22rem);
  position: relative;
  z-index: 1;
}

:deep(.word-brand) {
  background: linear-gradient(120deg, #6fa6ff 0%, #bd8bff 45%, #7ea5ff 75%, #d2b2ff 100%);
  background-size: 220% 220%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-shadow: 0 0 14px rgba(127, 166, 255, 0.28);
  animation: zima-brand-shift 4.2s ease-in-out infinite;
  will-change: background-position;
}

.callouts {
  padding: 16px 18px 16px 20px;
  border-radius: 14px;
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(circle at 92% 12%, rgba(155, 89, 182, 0.1), transparent 40%),
    radial-gradient(circle at 8% 90%, rgba(78, 115, 223, 0.09), transparent 44%),
    linear-gradient(125deg, rgba(78, 115, 223, 0.12), rgba(155, 89, 182, 0.08));
  border: 1px solid transparent;
  border-left: none;
  color: #edf3ff;
  line-height: 1.6;
  box-shadow:
    0 8px 26px rgba(0, 0, 0, 0.32),
    0 0 0 1px rgba(115, 148, 240, 0.14) inset;
}

.callouts::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: linear-gradient(180deg, rgba(78, 115, 223, 0.8) 0%, rgba(155, 89, 182, 0.78) 100%);
  z-index: 2;
}

.callouts::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 14px;
  padding: 1px;
  background: linear-gradient(120deg, rgba(78, 115, 223, 0.36), rgba(155, 89, 182, 0.34));
  -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
  z-index: 1;
}

.callouts p + p {
  margin-top: 4px;
}

.callouts strong {
  color: #ecf2ff;
  font-weight: 700;
  font-style: italic;
  position: relative;
  z-index: 3;
}

.divider-label {
  margin-top: 4px;
  color: #e5edff;
  font-weight: 650;
}

.strong {
  color: #eef3ff !important;
  font-weight: 700;
}

.italic-quote {
  font-style: italic;
}

@keyframes zima-brand-shift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>


